import React from "react";
import CommonUtil from "utils/CommonUtil";

export type IBSheetProp = {
    options: any;
    sheetStyle?: React.CSSProperties;
    data?: any;
    onBind?: (ibsheet: any) => void;
}

type RenderFirstFinishArgs = {
    eventName: string;
    sheet: any;
}

export default class IBSheetContainer extends React.Component<IBSheetProp> {
    private readonly sheetEl = "sheetContainer" + CommonUtil.getUid();
    private readonly sheetId = "sheet" + CommonUtil.getUid();
    state: any = {
        sheetObj: undefined
    }

    constructor(props: IBSheetProp) {
        super(props);
    }

    componentDidMount() {
        if (!this.props.options.Events) this.props.options.Events = {}
        if (this.props.options.Events.onRenderFirstFinish) {
            const orgRenderFirstFinish = this.props.options.Events.onRenderFirstFinish;
            const propOnBind = this.props.onBind;
            this.props.options.Events.onRenderFirstFinish = function (event: RenderFirstFinishArgs) {
                propOnBind && propOnBind(event.sheet);
                orgRenderFirstFinish(event);
            }
        } else {
            const propOnBind = this.props.onBind;
            this.props.options.Events.onRenderFirstFinish = function (event: RenderFirstFinishArgs) {
                propOnBind && propOnBind(event.sheet);
            }

        }

        const sheetObj = window.IBSheet.create({
            el: this.sheetEl,
            options: this.props.options,
            data: this.props.data
        })
        this.setState({...this.state, sheetObj})
    }

    componentWillUnmount() {
        this.state.sheetObj?.dispose();
    }

    render() {
        return (
            <div className="ibsheet">
                <div id={this.sheetEl} key={this.sheetId} style={{height:"auto", ...this.props.sheetStyle}}>[D] IBSHEET 영역</div>
            </div>
        )
    }
}